import { call, put } from 'redux-saga/effects';
import { onSaveVehicleDataFailure, onSaveVehicleDataSuccess } from '../actions';
import { VehicleService } from '../services';
/**
 * Saga to handle the request to get job vehicle and
 * notify other vehicle associated domains to fill state like vehicle color, attributes, options etc.
 * @param action
 * @param vehicleService
 */
export function* saveJobVehicleSaga(action, 
/*istanbul ignore next*/
vehicleService = VehicleService.getInstance()) {
    try {
        const result = yield call({
            fn: vehicleService.SaveJobVehicleData,
            context: vehicleService
        }, action.payload.jobId, action.payload.jobVehicleData, action.payload.companyDefinedFieldsRequestPayload);
        //success action to notify store to referesh vehicle data
        yield put(onSaveVehicleDataSuccess(result));
    }
    catch (exception) {
        yield put(onSaveVehicleDataFailure(exception.toString()));
    }
}
//# sourceMappingURL=saveJobVehicleSaga.js.map